import { ConfirmEmailForm } from '@/components'
import { Footer } from '@/components/nav/Footer'

export function ConfirmEmailPage() {
    return (
        <>
            <section className="bg-gray-50 dark:bg-gray-900">
                <ConfirmEmailForm />
            </section>
            <Footer />
        </>
    )
}
